import React, {useEffect} from 'react'
import { Button } from 'react-bootstrap'
import ReactGA from 'react-ga';

const Header = () => {
    useEffect(() => {
      ReactGA.initialize('G-0FEQG8PQKQ');
      ReactGA.pageview(window.location.pathname);
    }, []);
    const handleClick = () => {
      ReactGA.event({
        category: 'Button',
        action: 'Click',
        label: 'Inscribete aqui'
      });
    }
  return (
    <>
      <div className='px-4 py-16 mx-auto sm:max-w-xl md:max-w-full md:px-24 lg:px-8  mb-14 bg-white'>
        <div className='p-8 sm:p-16'>
          <div className='flex flex-col lg:flex-row -mt-14'>
            <div className='mb-6 lg:mb-0 lg:w-1/2 lg:pr-5'>
              <h2 className='max-w-lg mb-6 font-sans text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none text-left'>
                ¿QUÉ ES LA UNIVERSIDAD INTERNACIONAL DE VERANO RANCAGUA 2023?
              </h2>
              <p className='text-base text-gray-700 md:text-lg text-left'>
                La Universidad pretende ser un espacio de reflexión, diálogo y
                colaboración entre actores e iniciativas de temas contingentes
                para el desarrollo regional, propiciando y ampliando de manera
                real la participación ciudadana. Buscamos abrir y difundir
                canales de diálogo, discusión, análisis y conocimiento de temas
                que impactan el diario vivir ciudadano.
              </p>
              <br />
              <p className='text-base text-gray-700 md:text-lg text-left'>
                Un acto político, cultural, artístico y ciudadano, capaz de
                convocar a los artistas, actores sociales, sindicales y un
                público.
              </p>
              <br />
              <p className='text-base text-gray-700 md:text-lg text-left'>
                Este 2023 el tema será <b>"Gobierno Abierto" GA.</b>
              </p>
              <br />
              <p
                className='text-base text-celeste_rancagua md:text-lg text-left'
                id='que_es'
              >
                <b>¿Qué es Gobierno Abierto? GA</b>
              </p>
              <br />
              <p className='text-base text-gray-700 md:text-lg text-left'>
                "Es una cultura de gobernanza basada en políticas públicas y
                prácticas innovadoras y sostenibles que se basan a su vez en
                unos principios de{' '}
                <b>transparencia, rendición de cuentas y participación</b> que
                promueven la democracia y el crecimiento inclusivo”
              </p>
              <br />
              <p className='text-base text-gray-700 md:text-lg text-left'>
                Este sistema crea una plataforma formal institucional, legal, y
                reglamentada, con principios y procesos claros, para que la voz
                del rancagüino sea escuchada, donde podrá participar
                colaborativamente en el trabajo municipal, podrá visibilizar sus
                problemas, y la de sus vecinos, podrá aportar con ideas para su
                solución, podrá ayudar a poner foco en el destino de los
                recursos municipales y fiscalizar el proceso, será un aliado en
                la gestión del municipal.
              </p>
              <br />
              <p className='text-base text-gray-700 md:text-lg text-left mb-2'>
                En base a los 3 PRINCIPIOS:{' '}
                <b>transparencia, participación y colaboración, </b>de modo
                integrado.
              </p>
              <div className='mt-3'>
                <Button
                    onClick={handleClick}
                    href='/inscripciones'
                    rel='noreferrer'
                    className='mx-auto lg:px-8 px-4 py-4  hover:bg-celeste_rancagua font-medium text-xl tracking-wide text-white capitalize transition-colors duration-300 transform bg-naranjo_rancagua rounded-lg mt-5 font-bold'
                >
                  INSCRÍBETE AQUÍ
                </Button>
              </div>
            </div>
            <div className='lg:w-1/2'>
              <img
                className='w-full h-56 rounded  lg:rounded-none lg:shadow-none sm:h-96 lg:h-full scale-75'
                src='/assets/ilustraciones/edit/9.svg'
                alt=''
              />
            </div>
          </div>
          <img
            src='/assets/ilustraciones/edit/10.svg'
            alt=''
            className='w-96 h-48 ml-auto md:-mt-28 -mt-10'
          />
        </div>
      </div>
    </>
  )
}

export default Header
